import React from 'react';
import Card, { CardProps } from 'react-bootstrap/Card';
import classes from './Card.module.scss';

interface ICard {
  // exporting interface is the only way to fix default props issue
  title?: string;
  children?: React.ReactNode;
  className?: string; // to be used to control title styling
}

type Props = CardProps & ICard;

const AppCard = ({ title = '', children = <div />, className = '' }: Props) => (
  <Card className={`${classes['card-style']} ${className}`}>
    <Card.Body>
      {title && <Card.Title>{title}</Card.Title>}
      {children}
    </Card.Body>
  </Card>
);
export default AppCard;
